import { useState } from 'react';
import { SignupForm, type SignupFormValues } from './SignupForm';
import { useSearchParams } from 'react-router';
import { useOrganizationValidation } from '@/hooks/organization/use-signup-token-validation';

export function SignupPage() {
  const [showConfirmPage, setShowConfirmPage] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');

  const [searchParams] = useSearchParams();
  const orgCreateToken = searchParams.get('orgCreateToken');
  const signupToken = searchParams.get('signupToken');
  const validation = useOrganizationValidation({
    orgCreateToken,
    signupToken,
  });

  if (validation.type === 'invalid') {
    console.warn('Invalid signup link', { orgCreateToken, signupToken });
    return <div>Invalid link. Please contact support.</div>;
  }

  const onSignupSuccess = (values: SignupFormValues) => {
    setEmail(values.email);
    setShowConfirmPage(true);
  };

  if (showConfirmPage) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-white">
        <div className="w-full max-w-md text-center">
          <h1 className="text-xl mb-3">Check your email</h1>
          <p className="text-slate-600">
            We sent a verification link to <strong>{email}</strong>. Click the
            link in the email to verify your account.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white">
      <div className="w-full max-w-md">
        {validation.type === 'token' ? (
          <SignupForm
            signUpType="create"
            onSuccess={onSignupSuccess}
            orgCreateToken={validation.orgCreateToken}
          />
        ) : (
          <SignupForm
            signUpType="join"
            onSuccess={onSignupSuccess}
            signupToken={validation.signupToken}
            presetEmail={validation.email}
          />
        )}
      </div>
    </div>
  );
}
